import React from 'react';
import axios from "axios";
import configData from "../../config/config.json";
import { connect } from "react-redux";
import FormTemplate from "../common/form/FormTemplate.js";
import { Form, Button, Container, Row, Col } from 'react-bootstrap'
import PageBanner from "../common/page/PageBanner";
import PrimaryButton from "../common/form/PrimaryButton";
import Alert from '../common/modal/Alert.js';
import { checkIconGreen, spinnerIconGray } from "../../img/font_awesome/font_awesome"
import { setSelectedControlPanelType, AccountsControlPanelKey } from "../../redux/actions/controlPanelActions.js";
import { saveAccount } from "../../redux/actions/accountActions.js";
import Loading from '../common/modal/Loading.js';
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";
import { idText } from 'typescript';

const componentName = AccountsControlPanelKey;

const mapStateToProps = (state) => {
	return {
		accountTypes: state.accountTypesReducer.codeDescriptionResultList,
		accountListFilters: state.accountListFiltersReducer,
		countyConfigFlatFee: state.countyConfigFlatFeeReducer,
		role: state.currentUserReducer.role,
		countyConfigBillingSchedule: state.countyConfigBillingScheduleReducer,
		availableDocumentTypes: state.documentTypesWithBlankReducer.codeDescriptionResultList
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
	}
}

const DEFAULT_IMAGE_CHARGE_METHOD = 'PAGE';

const NO_ID = 0;

class AccountDocTypes extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			accountId: NO_ID,
			errors: {},
			showAlert: false,
			alertMessage: "",
			redirect: false,
			status: ''
		};

		this.state = { ...this.state, ...this.getStateFromContent(null) };
	}

	handleChange = (event) => {
		event.preventDefault();

		let value = event.target.value;

		this.setState({
			[event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value),
			errors: {},
			status: ''
		});

	}

	getContainer = () => {
		return {
			accountId: this.state.accountId,
			accountDocTypes: this.state.docTypes
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();

		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
		} else {
			return;
		}

		axios.post(configData.LANDSHARK_SERVER_URL + "controlPanel/accountDocTypes", this.getContainer(), { withCredentials: true })
			.then((response) => {
				const content = response.data.content;
				let newState = {
					...this.getStateFromContent(content),
					status: "SUCCESS",
					redirect: false
				};

				this.setState(newState);
			}, (error) => {
				this.setState({ status: "", redirect: false }, this.showAlert(error.message));
			});
	}

	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/controlPanel/accounts');
	}

	showLoading = () => {
		if ((this.state.status === "") || (this.state.status === "SUCCESS")) {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				status: ""
			})
		} else {
			this.setState({
				status: ""
			})
		}
	}

	createDefaultRow = () => {
		return {
			accountId: this.state.accountId,
			documentType: '',
			id: NO_ID,
			imageChargeMethod: DEFAULT_IMAGE_CHARGE_METHOD,
			imageRetrieval: true,
			previewRetrieval: true
		};
	}

	handleMoreRows = (event) => {
		event.preventDefault();

		let newRows = [];

		for (let i = 0; i < 5; ++i) {
			newRows = newRows.concat([this.createDefaultRow()]);
		}

		this.setState({
			status: '',
			docTypes: [...this.state.docTypes, ...newRows]
		});
	}

	handleChange = (event) => {
		const targetId = event.target.id;
		console.log(targetId);
		let docTypes = [...this.state.docTypes];

		if (targetId.includes("documentType")) {
			const index = targetId.replace("documentType", "");
			let docType = { ...docTypes[index] };
			docType.documentType = event.target.value;
			docTypes[index] = docType;
			this.setState({
				status: "",
				docTypes
			});
		} else if (targetId.includes("imageChargeMethod")) {
			const index = targetId.replace("imageChargeMethod", "");
			let docType = { ...docTypes[index] };
			docType.imageChargeMethod = event.target.value;
			docTypes[index] = docType;
			this.setState({
				status: "",
				docTypes
			});
		} else if (targetId.includes("imageRetrieval")) {
			const index = targetId.replace("imageRetrieval", "");
			let docType = { ...docTypes[index] };
			docType.imageRetrieval = event.target.value;
			docTypes[index] = docType;
			this.setState({
				status: "",
				docTypes
			});
		} else if (targetId.includes("previewRetrieval")) {
			const index = targetId.replace("previewRetrieval", "");
			let docType = { ...docTypes[index] };
			docType.previewRetrieval = event.target.value;
			docTypes[index] = docType;
			this.setState({
				status: "",
				docTypes
			});
		} else {
			this.setState({
				status: "",
				[event.target.id]: event.target.value ? event.target.value : 0
			})
		}
	}

	handleReorganizeRows = (event) => {
		event.preventDefault();

		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
		} else {
			return;
		}

		axios.post(configData.LANDSHARK_SERVER_URL + "controlPanel/accountDocTypes/organize", this.getContainer(), { withCredentials: true })
			.then((response) => {
				const content = response.data.content;
				let newState = {
					...this.getStateFromContent(content),
					status: "",
					redirect: false
				};

				this.setState(newState);
			}, (error) => {
				this.setState({ status: "", redirect: false }, this.showAlert(error.message));
			});
	}

	handleRemoveRow = (event) => {
		let indexToRemove = event.target.id.replace("remove", "");
		indexToRemove = parseInt(indexToRemove);
		let docTypes = this.state.docTypes;
		docTypes.splice(indexToRemove, 1);
		this.setState({
			status: "",
			docTypes: docTypes
		})
	}

	showAlert = (alertMessage) => {
		this.setState({
			showAlert: true,
			alertMessage
		})
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: '',
			alertType: ''
		})

		if (this.state.redirect) {
			this.props.history.push('/controlPanel/accounts');
		}
	}

	componentDidMount() {
		axios.get(configData.LANDSHARK_SERVER_URL + "controlPanel/accountDocTypes/" + this.props.match.params.id, { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let newState = this.getStateFromContent(content);

					this.setState(newState);
				},
				(error) => {
					console.log(error);
				}
			);
	}

	getStateFromContent = (content) => {
		if (content === null) {
			return {
				accountId: NO_ID,
				docTypes: [this.createDefaultRow()]
			};
		} else {
			let container = content.accountDocTypesContainer;

			return {
				docTypes: container.accountDocTypes,
				accountId: container.accountId
			};
		}
	}

	trueFalseOptions = (isTrue) => {
		if (isTrue) {
			return <>
				<option key="true" selected value="true">Yes</option>
				<option key="false" value="false">No</option>
			</>;
		} else {
			return <>
				<option key="true" value="true">Yes</option>
				<option key="false" selected value="false">No</option>
			</>;
		}
	}

	chargeMethodOptions = (method) => {
		if (method === 'PAGE') {
			return <>
				<option key="Document" selected value="DOCUMENT">Document</option>
				<option key="Page" value="PAGE">Page</option>
			</>;
		} else {
			return <>
				<option key="Document" value="DOCUMENT">Document</option>
				<option key="Page" selected value="PAGE">Page</option>
			</>;
		}
	}

	render() {
		let formTemplateMarginLeft;
		let formTemplateMarginRight;

		console.log('bxp: sideNavigationOpen: ' + this.props.sideNavigationOpen);

		if (this.props.formOnly) {
			formTemplateMarginLeft = 0
			formTemplateMarginRight = 0
		} else {
			formTemplateMarginLeft = 270
			formTemplateMarginRight = 20
		}

		let pageButtons = [{ label: 'Add', onClickAction: this.handleMoreRows, className: 'btn btn-secondary btn-sm' }, { label: 'Organize', onClickAction: this.handleReorganizeRows, className: 'btn btn-secondary btn-sm' }]

		let docTypesTable =
			<div>
				{
					this.state.docTypes.map((docType, index) => (
						<Form.Row>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4, minWidth: 300 }}>
									{
										<Form.Control as='select' id={'documentType' + index} disabled={this.state.status === LOADING_STATUES.LOADING} onChange={this.handleChange}  >
											{
												this.props.availableDocumentTypes &&
												this.props.availableDocumentTypes.map((option) => {
													if (docType.documentType === option.code)
														return (<option key={option.code} selected value={option.code}>{option.description}</option>)
													else
														return (<option key={option.code} value={option.code}>{option.description}</option>)
												})
											}
										</Form.Control>
									}
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									{
										<Form.Control as='select' id={'imageChargeMethod' + index} disabled={this.state.status === LOADING_STATUES.LOADING} onChange={this.handleChange} value={this.state.docTypes[index].imageChargeMethod} style={{ maxWidth: 130 }}>
											{this.chargeMethodOptions(this.state.docTypes[index].imageChargeMethod)}
										</Form.Control>
									}
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									{
										<Form.Control as='select' id={'previewRetrieval' + index} disabled={this.state.status === LOADING_STATUES.LOADING} onChange={this.handleChange} value={this.state.docTypes[index].previewRetrieval} style={{ maxWidth: 130 }} >
											{this.trueFalseOptions(this.state.docTypes[index].previewRetrieval)}
										</Form.Control>
									}
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									{
										<Form.Control as='select' id={'imageRetrieval' + index} disabled={this.state.status === LOADING_STATUES.LOADING} onChange={this.handleChange} value={this.state.docTypes[index].imageRetrieval} style={{ maxWidth: 130 }} >
											{this.trueFalseOptions(this.state.docTypes[index].imageRetrieval)}
										</Form.Control>
									}
								</div>
							</Col>
							<Col>
								{
									(index > -1) &&
									<Button id={'remove' + index} variant="danger" size="sm" style={{ margin: 1 }} disabled={this.state.status === LOADING_STATUES.LOADING} onClick={this.handleRemoveRow}>Remove</Button>
								}
							</Col>
						</Form.Row>
					))
				}
			</div>

		return (
			<div style={{ marginLeft: formTemplateMarginLeft, marginRight: formTemplateMarginRight, marginTop: 4, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }}>
				<PageBanner pageHeading={"Account Document Type Settings - " + this.props.match.params.name} buttons={pageButtons} />
				<Container fluid="true" style={{ paddingLeft: 50, paddingBottom: 50, marginTop: 10, marginLeft: 4, marginRight: 4, border: '3px solid darkGray', borderRadius: '5px' }}>
					<Row>&nbsp;</Row>
					<Form onSubmit={this.handleSubmit}>
						<Form.Row>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4, minWidth: 300 }}>
									<div>Document Type:</div>
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									<div>Charge Method:</div>
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									<div>Show Preview:</div>
								</div>
							</Col>
							<Col>
								<div style={{ display: 'inline-block', marginLeft: 4 }}>
									<div>Show Image:</div>
								</div>
							</Col>
							<Col>
							</Col>
						</Form.Row>
						{docTypesTable}
						<Row>&nbsp;</Row>
						<PrimaryButton buttonLabel="Submit" disabled={this.state.status === LOADING_STATUES.LOADING} />&nbsp;&nbsp;
						{
							this.state.status === LOADING_STATUES.SUCCESS &&
							<span style={{ width: 18, verticalAlign: "bottom", paddingBottom: 1, display: "inline-block" }}>{checkIconGreen}</span>
						}
						{
							this.state.status === LOADING_STATUES.LOADING &&
							<span style={{ width: 18, verticalAlign: "bottom", marginBottom: 1, display: "inline-block" }}>{spinnerIconGray}</span>
						}
					</Form>
				</Container>
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={ALERT_TYPES.WARNING} />
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDocTypes);
